import type { SerializedEditorState } from './Lexical';
import type { EmailHeaders } from './Email';
import type { ActionType } from './TaskSynthesis';

export type DraftType = 'email' | 'proposal' | 'review' | 'brief' | 'outline' | 'creative' | 'meeting' | 'summary' | 'slides';
export type CapitalDraftType = 'Email' | 'Proposal' | 'Review' | 'Brief' | 'Summary' | 'Creative' | 'Outline' | 'Meeting' | 'Slides';

export const DraftTypeList = ['email', 'proposal', 'review', 'brief', 'outline', 'creative', 'meeting', 'summary', 'slides'];

export interface DraftContent {
  id?: string; // Draft ID (asset ID when loaded from database)
  draftType?: DraftType | 'taskplan';
  title?: string; // Title for non-email drafts
  emailHeaders?: EmailHeaders;
  content: string;
  summary?: string;
  lexicalState?: SerializedEditorState;
  lastModified?: number;
  isAgentUpdate?: boolean; // Flag to indicate this update came from AI (for immediate persistence)
  data?: Record<string, unknown>;
}


// Map action types to draft types
export const ACTION_TO_DRAFT_TYPE: Record<ActionType, DraftType> = {
  email: 'email',
  summary: 'outline',
  proposal: 'proposal',
  analysis: 'outline',
  creative: 'creative',
  outline: 'outline',
  brief: 'brief',
  review: 'review',
  campaign: 'creative', 
  article: 'creative',
  strategy: 'creative',
  design: 'creative',
  launch: 'creative',
  meeting: 'meeting',
  report: 'brief',
  slides: 'slides'
};